import { css } from 'styled-components';

export const QRCode = css`position: fixed; bottom: 0; margin-right: 10%; margin-bottom: 1.5rem; width: 90%`;
export const QRCodeMultiProduct = css`position: fixed; bottom: 0; margin-right: 10%; margin-bottom: 1.5rem; background-color: white; width: 90%`;
export const Subtitle = css`word-wrap: break-word; margin-bottom: 15px;`;
export const ImageContainer = css`align-items: center;`;
